import { getLocalStorageAuth } from "../localStorage";

// const { REACT_APP_API_KEY } = process.env;

const defaultHeaders = {
  "Content-Type": "multipart/form-data",
  // "x-key": REACT_APP_API_KEY,
};

export const configHeader = ({ auth = false }) => {
  try {
    const token = getLocalStorageAuth();
    const authHeaders = auth && {
      Authorization: `Bearer ${token}`,
    };
    return {
      ...defaultHeaders,
      ...authHeaders,
    };
  } catch (error) {
    console.log("error", error);
  }
};
